<template>
	<v-dialog
		v-model="localIsVisible"
		:width="$vuetify.display.mobile ? '95%' : '900px'"
		@click:outside="closeCard"
		@keydown.esc="closeCard"
	>
		<v-sheet
			:height="$vuetify.display.mobile ? '90vh' : '75vh'"
			v-if="localIsVisible"
			class="dialog-sheet sgnl-flex sgnl-flex-column"
		>
			<div class="dialog-header sgnl-flex-shrink-0">
				<span class="sgnl-subtitle-medium">Execution Results</span>
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="closeCard"
				>
					<Close16 />
				</v-btn>
			</div>
			<v-divider />
			<div class="dialog-body results-panel-body">
				<Panel
					:key="`${taskID}-${buildID}`"
					:taskID="taskID"
					:buildID="buildID"
					:showCopyButton="true"
				/>
			</div>
		</v-sheet>
	</v-dialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";

// Types
import Panel from "@/components/Panel.vue";
import { TaskOutput } from "@/types/api/tasks";

// Utilities

// Components
import { ResultsPanelTab } from "@/types/general";

// GlobalVariables
import { defaultTabs } from "@/assets/defaultTabs";

type ComponentData = {
	results: null | ResultsPanelTab[];
	resultsLoading: boolean;
};
export default defineComponent({
	name: "ExecutionResultsCard",
	components: { Panel, Close16 },
	props: {
		isVisible: { type: Boolean, default: false },
		taskOutputStreams: { type: Object as PropType<null | TaskOutput>, default: null },
		taskID: { type: String, default: undefined },
		buildID: { type: String, default: undefined },
	},
	emits: ["click-outside", "update:isVisible"],
	data: (): ComponentData => ({
		results: null,
		resultsLoading: false,
	}),
	methods: {
		closeCard() {
			// this.clearResults();
			this.$emit("click-outside");
		},
	},
	computed: {
		localIsVisible: {
			get(): boolean {
				return this.isVisible;
			},
			set(value: boolean) {
				this.$emit("update:isVisible", value);
			},
		},
		resultsPanelText(): readonly ResultsPanelTab[] {
			return this.results ?? defaultTabs;
		},
	},
});
</script>

<style lang="scss" scoped>
.results-panel-body {
	flex: 1;
	min-height: 0;
	overflow: hidden;
}
</style>
